








import { Member } from "@/api/models";
import { notEmptyString } from "@/api/validators";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MemberView extends Vue {
  @Prop({ default: () => new Member() }) member: Member;
  @Prop({ default: "" }) label: string;

  get hasLabel() {
    return notEmptyString(this.label, 2);
  }

  get mailLink() {
    return notEmptyString(this.member.identifier, 5) ? `mailto:${this.member.identifier}` : '#';
  }

  get hasDescription() {
    return notEmptyString(this.member.description);
  }

  get extraRowClasses() {
    return this.hasLabel ? ['field'] : [];
  }

  get info() {
    return this.member.isLead ? "Project lead" : "Linked team member";
  }

}
